import { render, staticRenderFns } from "./DiceExampleSlide.vue?vue&type=template&id=779f48d2"
import script from "./DiceExampleSlide.vue?vue&type=script&lang=js"
export * from "./DiceExampleSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779f48d2')) {
      api.createRecord('779f48d2', component.options)
    } else {
      api.reload('779f48d2', component.options)
    }
    module.hot.accept("./DiceExampleSlide.vue?vue&type=template&id=779f48d2", function () {
      api.rerender('779f48d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/DiceExampleSlide.vue"
export default component.exports